import OrderService from '@services/order/api'
import { GENERAL_STORE } from '@apps/order-form/src/store'

export const LAST_ORDER_MODULE = 'lastOrderModule'

export default {
  namespaced: true,
  state: {
    lastOrderData: {
      suggestions: null,
      template: null,
    },
  },

  getters: {
    lastOrderSuggestions: state => state.lastOrderData.suggestions,
    lastOrderTemplate: state => state.lastOrderData.template,
  },

  mutations: {
    setLastOrderData(state, { key, value }) {
      state.lastOrderData[key] = value
    },
  },

  actions: {
    async getLastOrderSuggestions({ commit, rootGetters }) {
      try {
        const response = await OrderService.getDotsLastOrder(
          rootGetters[`${GENERAL_STORE}/selectedCity`].id
        )

        commit('setLastOrderData', { key: 'suggestions', value: response })
      } catch (e) {
        commit('setLastOrderData', { key: 'suggestions', value: null })
      }
    },
    async getLastOrderData({ getters, commit }) {
      const { orderId } = getters.lastOrderSuggestions

      if (!orderId) return

      const { template } = await OrderService.getOrderTemplate({ orderId, templateType: 1 })

      commit('setLastOrderData', { key: 'template', value: template })
    },
    async getLastOrderState({ dispatch, getters }) {
      await dispatch('getLastOrderSuggestions')
      if (getters.lastOrderSuggestions) await dispatch('getLastOrderData')
    },

    async setLastOrderDot({ state, dispatch }, { targetDot, suggestion }) {
      const pickupDot = suggestion.idx
        ? // На 1 меньше потому что в точках доставки соответственно нет точки забора, которая придёт под индексом 0
          state.lastOrderData.template.deliveryDots[suggestion.idx - 1]
        : state.lastOrderData.template.pickupDot

      // Удаляем лишние поля
      pickupDot.items = []
      delete pickupDot.timeTo
      delete pickupDot.timeFrom
      delete pickupDot.date

      dispatch(`${GENERAL_STORE}/setDeliveryObject`, { pickupDot, targetDot }, { root: true })
    },

    async setLastOrderInitialState({ dispatch, getters, rootGetters }) {
      // Если нет успешного заказа по акутальному городу или уже установлен какой-либо адрес - выходим (например поставили адрес из адресной книги и сменился город)
      const orderDots = rootGetters[`${GENERAL_STORE}/orderDots`]

      if (!getters.lastOrderSuggestions || orderDots[0].address) return

      await dispatch('setLastOrderDot', {
        targetDot: orderDots[0],
        suggestion: { idx: 0 }, // Передаём номер точки забора из последнего закака
      })
    },
  },
}
